import { jsx as _jsx } from "react/jsx-runtime";
var PlayCircle = function PlayCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.5 14.5996L14.309 11.9996L11.5 9.40059V14.5996ZM15.98 13.1787L12.338 16.5487C12.019 16.8447 11.604 16.9997 11.181 16.9997C10.948 16.9997 10.711 16.9517 10.488 16.8547C9.878 16.5887 9.5 16.0197 9.5 15.3697V8.62969C9.5 7.98069 9.878 7.41069 10.488 7.14569C11.114 6.87069 11.841 6.99069 12.339 7.45169L15.98 10.8217C16.311 11.1267 16.5 11.5567 16.5 11.9997C16.5 12.4437 16.311 12.8727 15.98 13.1787ZM12 1.99969C6.486 1.99969 2 6.48669 2 11.9997C2 17.5137 6.486 21.9997 12 21.9997C17.514 21.9997 22 17.5137 22 11.9997C22 6.48669 17.514 1.99969 12 1.99969Z",
      fill: color
    })
  });
};
export default PlayCircle;